module.exports = __webpack_public_path__ + "static/media/menu-unidades.1b5eb7d4.svg";